exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-results-button{font-size:18px;font-weight:900;letter-spacing:.2px;text-align:center;padding:10px;margin-left:10px;margin-bottom:10px}.view-results-button:after{background:#000;z-index:-1}.filter-buttons{display:flex;flex-direction:column;justify-content:flex-end;align-items:flex-end}", ""]);

// exports
